import React from "react";

export default function About() {
  return (
    <>
      <article className="mt-8 text-dark leading-7 tracking-wider">
        <p className="font-bold">Hi, Saya Dzil. </p>
        <p>
          Raya Kreasi adalah sebuah unit usaha untuk membantu sponsor utama Kami
          yaitu PT. Pelayaran Tresnamuda Sejati. Kami berusaha menyediakan
          Sistem Informasi yang baik untuk memodernisasi sistem lama yang sudah
          ada sebelumnya.
        </p>

        <p>"Membuat sesuatu yang simpel adalah yang paling tersulit".</p>
        <footer className="mt-12">
          <p>Thanks & Regards,</p>
          <p>Dzil</p>
          <p>Email: dzil@tresnamuda.co.id; dziljalal1@gmail.com </p>
          <p>Phone: +62 813 4949 5897</p>
        </footer>
      </article>
    </>
  );
}
